module.exports = __webpack_public_path__ + "static/img/20231208_05.63f7059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231208_05.png
// module id = Cwvn
// module chunks = 0